import { app } from './Api';
import { appblob } from './ApiBlob';

const get = async (page, qtdPerPage) => {
    return app.get(`ura?page=${page}&qtd_per_page=${qtdPerPage}`);
};

const destroy = async (id, motivo_exclusao) => {
    return app.delete(`ura/${id}`, { data: { motivo_exclusao } });
};

const getExcel = async (unidade_id = '', status = '', initialDate = '', finalDate = '') => {
    return appblob.get(
        `relatorio/ura?unidade_id=${unidade_id || ''}&status=${status || ''}&initialDate=${initialDate || ''}&finalDate=${finalDate || ''}`
    );
};

export { get, destroy, getExcel };
